// removed by extract-text-webpack-plugin
module.exports = {"custom-toc":"CustomToc__custom-toc___13JmI_0","customToc":"CustomToc__custom-toc___13JmI_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true,"localIdentName":"[name]__[local]___[hash:base64:5]_0","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4058210","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CustomToc.vue
// module id = 111
// module chunks = 0